import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-icon-tooltip',
  templateUrl: './icon-tooltip.component.html',
  styleUrls: ['./icon-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconTooltipComponent implements OnInit {
  @Input() text = '';
  constructor() { }

  ngOnInit(): void {
  }

}
